import React from 'react';
import PropTypes from 'prop-types';
import {
    FIELD_ERROR_CLASS,
    FIELD_STANDARD_CLASS,
    USERNAME_INVALID_MSG,
} from '../../../helpers/messageText';

class FieldUsername extends React.Component {
    renderClass = valid => {
        if (valid) {
            return FIELD_STANDARD_CLASS;
        } else {
            return FIELD_ERROR_CLASS;
        }
    };

    renderMessage = valid => {
        if (!valid) {
            return <div className="small form-control-feedback">{USERNAME_INVALID_MSG}</div>;
        }
    };

    handleChange = e => {
        if (this.props.handleChange) this.props.handleChange(e);
    };

    render() {
        return (
            <div className={this.renderClass(this.props.fieldState)}>
                <label className="col-2 col-form-label">Username</label>
                <div className="col-sm-10">
                    <div className="input-group">
                        <input
                            ref={input => (this.username = input)}
                            type="text"
                            name="username"
                            onChange={this.handleChange}
                            className="form-control"
                            value={this.props.defaultValue}
                            placeholder=""
                            autoFocus
                        />
                    </div>
                    {this.renderMessage(this.props.fieldState)}
                </div>
            </div>
        );
    }
}

FieldUsername.propTypes = {
    handleChange: PropTypes.func.isRequired,
    fieldState: PropTypes.bool.isRequired,
};

export default FieldUsername;



// WEBPACK FOOTER //
// ./src/containers/_shared/Fields/Username.js